export default "__VITE_ASSET__Cyn1W_VM__"